import { useProfileFilters } from "@/features/categories/hooks/useCompanies";

export function useProfileFilterOptions() {
  const { data, isLoading, error } = useProfileFilters();

  return {
    countries: data?.countries ?? [],
    seniorities: data?.seniorities ?? [],
    departments: data?.departments ?? [],
    isLoading,
    error,
  };
}
